export default [{
  path: '/charge/adcharge',
  name: 'AdCharge',
  component: () => import('@/views/charge/AdCharge')
}]
